import withHandlers from 'recompose/withHandlers';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import {
  getRoleIdType,
} from '../../../auth/selectors';
import {
  startTimerBarber,
  startTimerShop,
  clockInModalClose,
} from '../actions';
import { ChurnZeroService, CLOCK_IN } from '../../../../modules/infra/observability/churnzero';

const mapStateToProps = state => ({
  shopOrBarber: getRoleIdType(state),
});

const mapDispatchToProps = {
  startTimerBarber,
  startTimerShop,
  clockInModalClose,
};

const clockInHandler = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    startTimer: props => () => {
      ChurnZeroService.track(CLOCK_IN);
      if (props.shopOrBarber.type === 'shop') {
        return props.startTimerShop(props.shopOrBarber.id);
      }

      return props.startTimerBarber(props.shopOrBarber.id);
    },
    cancel: props => () => props.clockInModalClose(),
  })
);

export default clockInHandler;
